export const required = value => value ? undefined : "Required.";

export const maxLength = (value, length) => {
  if (!value) return;
  if (value.length > length) {
    return `Less than ${length} characters.`;
  }
}

export const numberRange = (value, min, max) => {
  if (typeof min !== 'number' && typeof max !== 'number') return;
  if (value < (min || 0)
    || value > (max || Number.POSITIVE_INFINITY)) {
    if (typeof min !== 'number') {
      return "Less than " + max;
    } else if (typeof max !== 'number') {
      return "More than " + min;
    } else {
      return "Between " + min + " and " + max;
    }
  }
}


// WEBPACK FOOTER //
// ./src/utils/validate.js